export const APPLICATION_STATUS = {
  Initiating: 'initiating',
  Initiated: 'initiated',
  Submitted: 'submitted',
}
